export default __webpack_public_path__ + "static/media/close-up-man-writing-code-on-the-laptop.5820388f.jpg";